import { ChangeDetectionStrategy, Component } from '@angular/core'
import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'

@Component({
  selector: 'bmcore-player-volume-control',
  templateUrl: './bmcore-player-volume-control.component.html',
  styleUrls: ['./bmcore-player-volume-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePlayerVolumeControlComponent extends PlayerListenerComponentDirective<any> {
  value = 50
  previousValue: number // need for show previous value when toggle sound icon

  constructor(player: PlayerLogic, cartService: CartService) {
    super(player, cartService)
  }

  toggleMuteSound() {
    if (this.value === 0) {
      this.value = this.previousValue
      this.player.changeVolume(this.value / 100)
    } else {
      this.previousValue = this.value
      this.value = 0
      this.player.changeVolume(this.value)
    }
  }

  changeVolumeHandler(value: number) {
    this.value = value
    this.player.changeVolume(value / 100)
  }
}
